import React, { useState, useEffect } from "react";
import ModalAddCandidate from "./ModalAddCandidate";
import { Form } from "antd";
import { url_get_list_district } from "../../../../constants";
import Cookies from "universal-cookie";
import { authAxios } from "../../../../utils";

const cookies = new Cookies();

const index = ({
  isModalOpenAddCandidate,
  onCancelAddCandidate,
  onFinishAddCV,
  dataDetail = [],
  listCandidateSource,
  listEducationLevel,
  // listLanguageSkill,
  handleChangeUploadCV,
  uploadFileCV,
  ls_city,
}) => {
  const [form] = Form.useForm();
  // const [selectedCity, setSelectedCity] = useState(null);
  const [listDistrict, setListDistrict] = useState([]);

  const onChangeCheckBoxGender = (e) => {
    form.setFieldsValue({ gender: e.target.value });
  };

  const handleCityChange = (e) => {
    form.setFieldsValue({ district_code: null });
    if (e == undefined) {
      setListDistrict([]);
    } else {
      // setSelectedCity(e);
      fetchListDistrict({ city_code: e });
    }
  };

  const fetchListDistrict = (params = {}) => {
    if (params.city_code != null) {
      authAxios(cookies.get("token"))
        .get(url_get_list_district, { params: params })
        .then((res) => {
          setListDistrict(res.data);
        })
        .catch((err) => {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              window.location = "/login";
            }
          }
          console.log(err);
          // openNotificationWithIcon('success','Thành công','');
        });
    }
  };

  // useEffect(() => {
  //   fetchListDistrict({ city_code: selectedCity });
  // }, [selectedCity]);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ gender: "Nam" });
  }, [isModalOpenAddCandidate]);

  return (
    <ModalAddCandidate
      form={form}
      isModalOpenAddCandidate={isModalOpenAddCandidate}
      onCancelAddCandidate={onCancelAddCandidate}
      onFinishAddCV={onFinishAddCV}
      onChangeCheckBoxGender={onChangeCheckBoxGender}
      dataDetail={dataDetail}
      listCandidateSource={listCandidateSource}
      listEducationLevel={listEducationLevel}
      // listLanguageSkill={listLanguageSkill}
      handleChangeUploadCV={handleChangeUploadCV}
      uploadFileCV={uploadFileCV}
      ls_city={ls_city}
      handleCityChange={handleCityChange}
      listDistrict={listDistrict}
    />
  );
};

export default index;
